module.exports = "\n<div class=\"content\">\n  <router-outlet></router-outlet>\n</div>\n"